module.exports = __webpack_public_path__ + "static/2-c054e52b7e401514c368fc12638c6642.jpg";